var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.experienceReviews
    ? _c("section", { attrs: { id: "experience-reviews" } }, [
        _vm.experience.status === 1 && _vm.experience.avg_rating
          ? _c("div", { staticClass: "experience-average-rating" }, [
              _c("i", { staticClass: "fas fa-star -rating-star mr-0" }),
              _vm._v(
                " " +
                  _vm._s(Number(_vm.experience.avg_rating).toFixed(1)) +
                  "\n    (" +
                  _vm._s(_vm.experience.num_rating) +
                  " " +
                  _vm._s(
                    _vm.$tc(
                      "message.professional.review",
                      _vm.experience.num_rating
                    )
                  ) +
                  ")\n  "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-3" },
          [
            _vm.experienceReviews
              ? [
                  _c("professional-reviews", {
                    attrs: {
                      professional: _vm.experience.professional,
                      professionalReviews: _vm.experienceReviews
                    },
                    on: { changedDisplayType: _vm.onChangeDisplayType }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-center" }, [
                    _vm.state.isMore
                      ? _c(
                          "a",
                          {
                            staticClass: "btn btn-outline-info",
                            attrs: { href: "", disabled: _vm.state.isFetching },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.loadMore.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t(_vm.isLoadMore)) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              : [_c("loader")]
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b1b829d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b1b829d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/experience/components/ExperienceReviews.vue
// module id = 1985
// module chunks = 0